import { useContext } from "react";
import { ActivationQueryData_datoCmsActivationConfig } from "../../../pages/__generated__/ActivationQueryData";
import { ConfigContext } from "../providers/config-provider";

export function useConfig(): ActivationQueryData_datoCmsActivationConfig {
  const values = useContext(ConfigContext);
  return values.config;
}
